"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PersonaCheckboxContainer_1 = require("./PersonaCheckboxContainer");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var ThreeLineViewFirstColumn = /** @class */ (function (_super) {
    tslib_1.__extends(ThreeLineViewFirstColumn, _super);
    function ThreeLineViewFirstColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThreeLineViewFirstColumn.prototype.render = function () {
        var isReadingPanePositionOff = false;
        return (React.createElement("div", { className: classNames(styles.firstColumnThreeColumn, 'fbAdLink') },
            React.createElement(PersonaCheckboxContainer_1.default, { isSelected: this.props.isSelected, isUnread: this.props.isUnread, isReadingPanePositionOff: isReadingPanePositionOff })));
    };
    ThreeLineViewFirstColumn = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThreeLineViewFirstColumn);
    return ThreeLineViewFirstColumn;
}(React.Component));
exports.default = ThreeLineViewFirstColumn;
//# sourceMappingURL=ThreeLineViewFirstColumn.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/ThreeLineViewFirstColumn.js
// module id = 6003
// module chunks = 67